import BaseIntegration from '@/common/mixins/integrations/baseIntegration';
import {mapMutations, mapActions, mapState} from "vuex";

const OmanOmantelIntegrationMixin = {
  extends: BaseIntegration,
  computed: {
    ...mapState('common', [
      'defaultDailySubButtonEnabled',
      'oneTimeSubscriptionBundleId'
    ])
  },
  methods: {
    ...mapActions('common', [
      'storeOperator'
    ]),
    ...mapActions('profile', [
      'storeLoginInfo',
      'getUserLoginDetails'
    ]),
    ...mapActions('i18n', [
      'updateUserLanguage'
    ]),
    ...mapMutations('common', [
      'setOneTimeSubscriptionBundleId'
    ]),
    ...mapMutations('profile', [
      'setRegistrationInfo',
    ]),
    getAlternateRequestPinActionImpl(isDailySubscription) {
      return () => {
        this.message = '';
        this.waitForResponse = true;
        const path = `publicapi/requestPinIntegration?msisdn=${this.user.msisdn}&lang=${this.getLocale}&operator=${this.operatorPicked}&isDefaultSubscription=${isDailySubscription}`;
        this.$axios.get(path).then((response) => {
          const resp = response.data.responseEnum;
          if (resp === 'OPERATION_SUCCESS') {
            this.user.msisdn = '';
            this.setRegistrationInfo(response.data.data[0]);
            sessionStorage.setItem('msisdn', response.data.data[0]);
            this.setOneTimeSubscriptionBundleId(response.data.data[1]);
            this.$router.push('register2');
            this.waitForResponse = false;
          } else {
            this.mapErrorMessages(resp);
            this.hasErrors = true;
            this.waitForResponse = false;
          }
        });
      }
    },
    getAlternateVerifyPinActionImpl() {
      return () => {
        if (this.defaultDailySubButtonEnabled) {
          this.$axios.get(`publicapi/verifyPinDailySubscription?msisdn=${this.registrationInfoMsisdn}&pin=${this.user.pin}&lang=${this.getLocale}&clickid=${this.getClickId || ''}&refUrl=${this.getRefUrl || ''}&publisherId=${this.getPublisherId || ''}&campaignId=${this.getCampaignId || ''}&asyncSub=true`).then((response1) => {
            const resp = response1.data.responseEnum;
            this.waitForResponse = false;
            if (resp === 'OPERATION_SUCCESS') { // proceed to authorization
              this.showLoadingModal = true;
              this.$axios.get(`api/getStatus?msisdn=${sessionStorage.getItem('msisdn')}&pin=${this.user.pin}&lang=${this.getLocale}&clickid=${this.getClickId || ''}&refUrl=${this.getRefUrl || ''}&publisherId=${this.getPublisherId || ''}&campaignId=${this.getCampaignId || ''}`).then((res) => {
                this.showLoadingModal = false;
                if (res.data.responseEnum === 'OPERATION_SUCCESS' && res.data.data) {
                  const hasSub = res.data.data.isSub;
                  if (hasSub === 'true') {
                    this.sendCompleteRegistrationEvent();
                  }
                  this.storeLoginInfo({
                    token: res.data.data.user_auth_token,
                    rememberMeParameter: false,
                    username: res.data.data.username,
                  });
                  this.getUserLoginDetails().then(() => {
                    this.updateUserLanguage().then(() => this.$router.push('home'));
                  });
                } else {
                  if (resp === 'PIN_EXPIRED') {
                    this.message = 'visitor_sign_up_2_pin_expired';
                  } else if (resp === 'WRONG_PIN') {
                    this.message = 'visitor_sign_up_2_warning_msg_wrong_verification_code';
                  } else if (resp === 'BLOCKED_USER') {
                    this.message = 'visitor_forgot_password_warning_msd_max_attempts';
                  } else if (resp === 'SERVER_ERROR') {
                    this.message = 'home_profile_profile_edit_server_unvailable';
                  } else if ((resp === 'THIRD_PARTY_PIN_REQUEST_FAILED') || (resp === 'THIRD_PARTY_PIN_VERIFICATION_FAILED') || (resp === 'THIRD_PARTY_SUBSCRIPTION_PIN_REQUEST_FAILED')) {
                    this.message = 'visitor_sign_up_warning_third_party_error';
                  } else if (resp === 'TEST_MSISDN_ACTION_PERFOMED') {
                    this.message = 'registration_process_with_test_msisdn_perfomed';
                  } else { // error case
                    this.$router.push('/');
                  }
                  this.showLoadingModal = false;
                  this.hasErrors = true;
                }
              });
            } else if (response1.data === 'OLD_PASSWORD_CHANGED') { // here user's password updated
              this.authorizationProcess();
            } else {
              this.showVerifyPinErrorMessage(resp);
            }
          });
        } else {
          this.$axios.get(`publicapi/chargeOneTimeSubscription?msisdn=${this.registrationInfoMsisdn}&pin=${this.user.pin}&lang=${this.getLocale}&bundleId=${this.oneTimeSubscriptionBundleId}&clickid=${this.getClickId || ''}&refUrl=${this.getRefUrl || ''}&publisherId=${this.getPublisherId || ''}&campaignId=${this.getCampaignId || ''}`).then((response1) => {
            const resp = response1.data.responseEnum;
            this.waitForResponse = false;
            if (resp === 'OPERATION_SUCCESS') { // proceed to authorization
              this.proceedToAutoLogin({
                query: {
                  user_auth_token: response1.data.data.user_auth_token,
                  username: response1.data.data.username
                }
              });
            } else if (response1.data === 'OLD_PASSWORD_CHANGED') { // here user's password updated
              this.authorizationProcess();
            } else {
              this.showErrorMessage(resp);
            }
          });
        }
      }
    }
  }
};

export default OmanOmantelIntegrationMixin;



// WEBPACK FOOTER //
// ./src/common/mixins/integrations/omanOmantelIntegration.js